import { Outlet } from 'react-router-dom';

import { AssistantBridge } from '@/components/assistant/assistant-bridge';
import { AssistantPanel } from '@/components/assistant/assistant-panel';
import { CommandPalette } from '@/components/layout/command-palette';
import { SidebarNav } from '@/components/layout/sidebar-nav';
import { TopBar } from '@/components/layout/top-bar';
import { useHotkeys } from '@/hooks/use-hotkeys';
import { useAssistantStore } from '@/state/assistant-store';
import { useUiStore } from '@/state/ui-store';

export function AppShell() {
  const setCommandPaletteOpen = useUiStore((state) => state.setCommandPaletteOpen);
  const copilotEnabled = useAssistantStore((state) => state.runtimeInfo?.enabled ?? false);

  useHotkeys([
    { key: 'k', ctrlOrMeta: true, handler: () => setCommandPaletteOpen(true) },
    { key: 'escape', handler: () => setCommandPaletteOpen(false) },
  ]);

  return (
    <div className="min-h-screen bg-[radial-gradient(circle_at_top,_rgba(80,227,194,0.10),_transparent_35%),linear-gradient(180deg,#060816_0%,#0f152e_42%,#10182c_100%)] bg-executive-grid bg-[size:24px_24px]">
      <div className="flex min-h-screen">
        <SidebarNav />
        <div className="flex min-h-screen flex-1 flex-col">
          <TopBar />
          <main className="flex-1 px-4 py-5 sm:px-5 xl:px-6">
            {copilotEnabled ? <AssistantBridge /> : null}
            <Outlet />
          </main>
        </div>
      </div>
      {copilotEnabled ? <AssistantPanel /> : null}
      <CommandPalette />
    </div>
  );
}
